
import { useNavigate, useParams } from 'react-router-dom'
import StudentInfoBoxWithData from '../studentGrid/studentinfoboxwithdata'
import GradeList from '../../instructor/studentGrid/sublist/gradelist'
import Transcript from '../../instructor/studentGrid/sublist/transcript'
// import Activities from '../../instructor/studentGrid/sublist/activities'
import BookList from '../../instructor/studentGrid/sublist/booklist'
import Personality from '../../instructor/studentGrid/sublist/personality'
import Colleges from '../../instructor/studentGrid/sublist/colleges'
// import Goalsettings from '../../instructor/studentGrid/sublist/goalsettings'
import { useRef,useState } from 'react'
import { useReactToPrint } from 'react-to-print'
import { logopcp } from '../../imagepath'
import AcademicAssessment from '../../instructor/studentGrid/sublist/academicAssessment'
import GlobalStudentActivityList from '../../pages/common/globalstudentactivitylist'
import GlobalStudentAwardsList from '../../pages/common/globalstudentawardlist'

const AdminStudentCollegeProfile = () => {
  const [mobileMenu, setMobileMenu] = useState(false)
  const navigate = useNavigate()
  let { slug } = useParams()
  console.log("slug :", slug)

  const componentRef = useRef()
   const handlePrint = useReactToPrint({
     content: () => {
       removeBorderClasses()
       return componentRef.current
     },
     onAfterPrint: () => {
       restoreBorderClasses()
     }
   })

   const removeBorderClasses = () => {
     const elements = document.querySelectorAll(
       '.border.border-3.border-primary'
     )
     const transcriptDiv = document.getElementById('transcript_div_pdf')
     console.log("transcriptDiv task: ", transcriptDiv)
      transcriptDiv.classList.add('pdf_transcript_div')
        transcriptDiv.classList.remove('transcript_div')
     const pdfLogo=document.getElementById("pdf_logo")
     pdfLogo.style.display="block"
     elements.forEach((element) => {
       element.classList.add('border-hidden')
       element.classList.remove('border', 'border-3', 'border-primary')
     })
   }

   const restoreBorderClasses = () => {
     const elements = document.querySelectorAll('.border-hidden')
      const pdfLogo = document.getElementById('pdf_logo')
      const transcriptDiv = document.getElementById('transcript_div_pdf')
       transcriptDiv.classList.remove('pdf_transcript_div')
       transcriptDiv.classList.add('transcript_div')
      pdfLogo.style.display = 'none'
     elements.forEach((element) => {
       element.classList.add('border', 'border-3', 'border-primary')
       element.classList.remove('border-hidden')
     })
   }

  return (
    <>
      <div className='main-wrapper'>
        <section className='course-content'>
          <div className='container-fluid w-100'>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <button
              onClick={() => navigate(-1)}
              className="btn btn-black btn-sm"
            >
              {"<< Back"}
            </button>
            <h3>College Profile</h3>
            <button
              onClick={handlePrint}
              className="btn btn-info-light next_btn"
              style={{ backgroundColor: "blue", color: "white" }}
            >
              Print Page
            </button>
          </div>
            <div className='card wish-card' ref={componentRef}>
              <div className='card-header'>
                <StudentInfoBoxWithData slug={slug} taskshow={false} />
                <img
                  src={logopcp}
                  className='img-fluid pdf_logo'
                  id='pdf_logo'
                  alt='Logo'
                  style={{ display: 'none' }}
                />
              </div>
              {/* <div className='page-break'>
                <Goalsettings slug={slug} />
              </div> */}
               <div className="page-break">
                <AcademicAssessment slug={slug} isProfile={true} />
              </div> 
              <span className='border border-3 border-primary'></span>
              <div className='page-break'>
                <Colleges slug={slug} />
              </div>
              <span className='border border-3 border-primary'></span>
              <div className='page-break'>
                <GradeList slug={slug} />
              </div>
              <span className='border border-3 border-primary'></span>
              <div className='page-break'>
                <Transcript slug={slug} />
              </div>
              <span className='border border-3 border-primary'></span>
              <div className="page-break">
                <GlobalStudentActivityList slug={slug} isStudent={false} show={false} />
              </div>
              <span className="border border-3 border-primary"></span>
              <div className="page-break">
                <GlobalStudentAwardsList slug={slug} isStudent={false} show={false} />
              </div>
              <span className='border border-3 border-primary'></span>
              <div className='page-break'>
                <BookList slug={slug} />
              </div>
              <span className='border border-3 border-primary'></span>
              <div className='page-break'>
                <Personality slug={slug} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default AdminStudentCollegeProfile
